import { Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import { getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils"
import _ from "lodash"

/**
 * 
 * @param {Object} props
 * @param {boolean} props.show - Object with
 *   {
 *     active: boolean
 *     macro: Object with {
 *              id: <optional>,
 *              is_enum: boolean,
 *              default_value: boolean,
 *              is_custom_mapping_active: boolean,
 *              lead_integration_macro_mappings: Array of objects { id: <optional>, input_value: string, output_value: string
 *            }
 *   }
 * @param {function} props.onAddClick - Callback function for submit, (updated_macro) => {}
 * @param {function} props.onCloseClick - Callback function for cancel
 * @param {string} props.title - Title of the modal (visible in UI at the top)
 *
 * @returns ReactElement
 */
const MappingsModal = ({ show, onAddClick, onCloseClick, title }) => {
  const [selectedMacro, setSelectedMacro] = useState(null)
  const [changedStateCount, setChangedStateCount] = useState(0)

  useEffect(() => {
    if (show?.active) {
      setChangedStateCount(changedStateCount + 1)
    }
  }, [selectedMacro]);

  const handleRowInput = (event) => {
    const { name, value  } = event.target
    setSelectedMacro(prevMacroState => {
      const updateDefaultValueOfInput = _.cloneDeep(prevMacroState)
      updateDefaultValueOfInput[name] = value;
      return updateDefaultValueOfInput;
    })
  }

  const handleGroupRowInput = (event, self_index) => {
    const { value, name } = event.target
    setSelectedMacro(prevMacroState => {
      const updateDefaultValueOfInput = _.cloneDeep(prevMacroState)
      updateDefaultValueOfInput.lead_integration_macro_mappings[self_index][name] = value;
      return updateDefaultValueOfInput;
    })
  }

  const handleIsCustomMappingState = (event) => {
    const { name } = event.target
    setSelectedMacro(prevMacroState => {
      const updateDefaultValueOfInput = _.cloneDeep(prevMacroState)
      updateDefaultValueOfInput[name] = !updateDefaultValueOfInput[name];
      return updateDefaultValueOfInput;
    })
  }

  return (
    <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='lg' onOpened={() => {
      setSelectedMacro(show?.macro || null);
    }}>
      <ModalHeader>
        <div className="d-flex justify-content-center">
          <i className={`align-self-bottom label-title bx  bx-customize ${getPrimaryTextClass()} me-1`}></i>
          <span className="modal-title text-black font-weight-semibold">
            {title} {" "} {show?.active ? `(${selectedMacro?.display_key})` : ""}
          </span>
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <div className="container">
          <FormGroup className="my-3 row">
            <Col md={6}>
              <Label className="form-control-label font-weight-semibold">Default Value</Label>
              <Input type="text" name="default_value" value={selectedMacro?.default_value || ""} onChange={handleRowInput} />
            </Col>
            {selectedMacro?.is_enum &&
              <Col md={12}>
                <div className="d-flex justify-content-between mt-3 mx-2">
                  <Label className="form-control-label font-weight-semibold">Custom Mapping</Label>
                  <div className="form-check form-switch form-switch-md red-green-bg-switch-btn">
                    <input
                      name="is_custom_mapping_active"
                      type="checkbox"
                      id="activeCheckButoon"
                      checked={selectedMacro?.is_custom_mapping_active}
                      className="form-check-input red-green-bg-switch-btn "
                      onChange={() => { }}
                      onClick={(event) => handleIsCustomMappingState(event, !setSelectedMacro?.is_custom_mapping_active)}
                    />
                    <label className="font-weight-semibold form-label mb-0" htmlFor="activeCheckButoon">
                      {selectedMacro?.is_custom_mapping_active ? "On" : "Off"}
                    </label>
                  </div>
                </div>
              </Col>
            }
          </FormGroup>
          <hr />
          {selectedMacro?.is_custom_mapping_active && <FormGroup className="d-flex row">
            <Col md='6'>
              <Label className="form-control-label font-weight-semibold">Input </Label>
            </Col>
            <Col md='6'>
              <Label className="form-control-label font-weight-semibold">Output</Label>
            </Col>
          </FormGroup>}
          {selectedMacro?.is_custom_mapping_active && selectedMacro?.lead_integration_macro_mappings.map((macro, self_index) => {
            return (
              <FormGroup className="my-3 row" key={self_index}>
                <Col md={6}>
                  <Input type="text" name="input_value" value={macro.input_value} onChange={(e) => handleGroupRowInput(e, self_index)} disabled />
                </Col>
                <Col md={6}>
                  <Input type="text" name="output_value" value={macro.output_value} onChange={(e) => handleGroupRowInput(e, self_index)} />
                </Col>
              </FormGroup>
            )
          })}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="text-center mt-3">
          <button
            type="button"
            className={`btn ${getPrimaryButtonClass()} ms-2`}
            onClick={() => {
              if (changedStateCount > 1) {
                onAddClick(selectedMacro);
              } else {
                onCloseClick();
              }
            }}>{"Add"}</button>
          <button type="button" className="btn btn-light ms-2" onClick={onCloseClick}>
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

MappingsModal.propTypes = {
  onCloseClick: PropTypes.func,
  onAddClick: PropTypes.func,
  show: PropTypes.any,
  title: PropTypes.any,
}

export default MappingsModal;

